import styled from 'styled-components'

interface StyledTitleProps {
  isFinished?: boolean
}

const CardTitle = styled.div<StyledTitleProps>`
  color: ${({ theme }) => theme.colors.primary };
  opacity: ${({ isFinished }) => isFinished ? '0.5' : '1' };
  font-family: Oswald;
  font-weight: 600;
  font-size: 24px;
  line-height: 1.1;
  margin-left: 8px;
`

export default CardTitle
